// date utils
import type { Locale } from '@seek/melways-sites';
import { absoluteDateFormatter } from '@seek/unified-display-date-time';
import { isBefore, isDate, isFuture } from 'date-fns';
import { fromZonedTime, toZonedTime } from 'date-fns-tz';

// @TODO: Does unification need to adjust anything here
const AU_TIMEZONE = 'Australia/Sydney';

export const addDays = (d: Date, n: number): Date =>
  new Date(new Date(d).setUTCDate(d.getUTCDate() + n));

export const formatDateText = (date: Date, locale?: Locale) => {
  const result = absoluteDateFormatter({
    date,
    format: 'short',
    locale,
  });
  return result.isValid ? result.formattedDate : '';
};

export const getDateDiffInDays = (a: Date, b: Date) => {
  const MS_PER_DAY = 1000 * 60 * 60 * 24;
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

  return Math.floor((utc2 - utc1) / MS_PER_DAY);
};

export const isoDateFromDate = (d: Date) => d.toISOString().split('T')[0];

export const isValidExpiryDate = (dateIsoString: string) => {
  const d = new Date(dateIsoString);
  // expiry date needs to be a date that's between now and max 30 days
  const notPastOrCurrent = isFuture(d);
  const notMoreThanMaxDayLimit = isBefore(d, addDays(d, 30));
  return isDate(d) && notPastOrCurrent && notMoreThanMaxDayLimit;
};

export const setUtcDateTime = (dateIsoString: string | Date) => {
  /* Ad expiry is based on AEST with the expiry time set to the end of the day.
   * i.e. 11:59:59pm AEST / 13:59 UTC (non-Daylight Savings) / 12:59:99 UTC (Daylight Savings)
   */
  const date = new Date(dateIsoString);
  date.setHours(23, 59, 59);

  // Handle DST based on Sydney timezone
  const utcDate = fromZonedTime(date, AU_TIMEZONE);
  return utcDate.toISOString();
};

export const setZonedDateTime = (date: string) => {
  const zonedDate = toZonedTime(date, AU_TIMEZONE);
  return zonedDate;
};

export const formatDateFromIsoDate = (
  dateIsoString: string,
  locale?: Locale,
) => {
  const date = new Date(dateIsoString);
  return formatDateText(date, locale);
};
